import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function QCMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Báo Cáo Phế Phẩm (NCR) & Kiểm Soát Chất Lượng
        </span>
        <span className="px-2 py-1 bg-red-100 text-red-700 rounded text-[10px] md:text-xs font-medium">
          Tỷ lệ Lỗi: 1.2%
        </span>
      </div>
      <div className="p-3 md:p-4 flex-1 flex flex-col gap-4 overflow-auto">
        <div className="grid grid-cols-4 gap-2 mb-2 text-center">
          <div className="bg-slate-50 border border-slate-200 rounded p-2">
            <div className="text-[9px] md:text-[10px] text-slate-500 mb-1">
              Tổng Lỗi Tháng 5
            </div>
            <div className="font-bold text-slate-800 text-xs md:text-sm">
              2,450 SP
            </div>
          </div>
          <div className="bg-red-50 border border-red-200 rounded p-2">
            <div className="text-[9px] md:text-[10px] text-red-600 mb-1">
              Thiệt Hại Ước Tính
            </div>
            <div className="font-bold text-red-700 text-xs md:text-sm">
              18.5 Triệu
            </div>
          </div>
          <div className="bg-slate-50 border border-slate-200 rounded p-2">
            <div className="text-[9px] md:text-[10px] text-slate-500 mb-1">
              Công Đoạn Lỗi Nhiều
            </div>
            <div className="font-bold text-slate-800 text-xs md:text-sm">
              Bế (45%)
            </div>
          </div>
          <div className="bg-slate-50 border border-slate-200 rounded p-2">
            <div className="text-[9px] md:text-[10px] text-slate-500 mb-1">
              Phân loại Lỗi
            </div>
            <div className="font-bold text-slate-800 text-[10px] md:text-xs">
              Lệch bế, rách màng
            </div>
          </div>
        </div>

        <div className="border border-slate-200 rounded-md overflow-hidden shadow-sm flex-1 flex flex-col">
          <table className="w-full text-left">
            <thead className="bg-slate-50 border-b border-slate-200 text-[9px] md:text-[10px] text-slate-500 uppercase">
              <tr>
                <th className="p-2 font-medium">Mã Lệnh</th>
                <th className="p-2 font-medium">Công Đoạn</th>
                <th className="p-2 font-medium">Mô tả Lỗi</th>
                <th className="p-2 font-medium text-center">Số Lượng</th>
                <th className="p-2 font-medium">Xử Lý</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 text-[10px] md:text-xs">
              <tr>
                <td className="p-2">
                  <span className="font-mono bg-slate-100 px-1 rounded">
                    PO-085
                  </span>
                </td>
                <td className="p-2">Máy Bế</td>
                <td className="p-2 font-medium text-slate-700">
                  Lệch mí bế 2mm
                </td>
                <td className="p-2 text-center text-red-600 font-bold">125</td>
                <td className="p-2">
                  <span className="bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded text-[9px]">
                    Chờ đánh giá
                  </span>
                </td>
              </tr>
              <tr>
                <td className="p-2">
                  <span className="font-mono bg-slate-100 px-1 rounded">
                    PO-080
                  </span>
                </td>
                <td className="p-2">Máy Dán</td>
                <td className="p-2 font-medium text-slate-700">
                  Tróc màng nilon do keo
                </td>
                <td className="p-2 text-center text-red-600 font-bold">45</td>
                <td className="p-2">
                  <span className="bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded text-[9px]">
                    Hủy - Bù hao
                  </span>
                </td>
              </tr>
              <tr>
                <td className="p-2">
                  <span className="font-mono bg-slate-100 px-1 rounded">
                    PO-078
                  </span>
                </td>
                <td className="p-2">Máy In</td>
                <td className="p-2 font-medium text-slate-700">
                  Lệch màu Cyan (đám mây)
                </td>
                <td className="p-2 text-center text-red-600 font-bold">
                  200 tờ
                </td>
                <td className="p-2">
                  <span className="bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded text-[9px]">
                    Hủy - Bù hao
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-100">
      <div className="bg-red-600 text-white p-3 shadow-md z-10 sticky top-0">
        <div className="text-sm font-bold flex items-center gap-2">
          <span>⚠️</span> Khai Báo Lỗi (NCR)
        </div>
      </div>

      <div className="flex-1 p-4 overflow-y-auto space-y-4">
        <div className="bg-white rounded-xl p-3 shadow-sm border border-slate-200">
          <div className="text-[10px] text-slate-500 font-medium mb-1 uppercase tracking-wider">
            Thông tin Lỗi
          </div>

          <div className="space-y-3 mt-2">
            <div>
              <label className="text-[10px] text-slate-600 block mb-1">
                Công đoạn
              </label>
              <div className="w-full bg-slate-50 border border-slate-200 rounded-lg p-2 text-xs font-bold text-slate-700">
                Máy Dán Tự Động
              </div>
            </div>
            <div>
              <label className="text-[10px] text-slate-600 block mb-1">
                Mã Lỗi (Nhóm Lỗi)
              </label>
              <div className="w-full bg-slate-50 border border-slate-200 rounded-lg p-2 text-xs text-slate-700">
                Lỗi Tróc Màng/Bong Keo (M14)
              </div>
            </div>
            <div className="flex gap-2">
              <div className="flex-1">
                <label className="text-[10px] text-slate-600 block mb-1">
                  Số lượng lỗi
                </label>
                <div className="w-full bg-slate-50 border border-red-200 text-red-600 rounded-lg p-2 text-xs font-bold">
                  45 Hộp
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 shadow-sm border border-slate-200 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-slate-900 flex items-center justify-center opacity-80">
            <span className="text-white font-bold text-xs">
              📷 Đã đính kèm 2 hình ảnh
            </span>
          </div>
          {/* Fake image thumbnail */}
          <div className="w-full h-24 bg-slate-200 rounded-lg"></div>
        </div>

        <button className="w-full bg-red-600 text-white py-3 rounded-lg text-xs font-bold shadow-md shadow-red-200 transition-colors hover:bg-red-700">
          Gửi Báo Cáo Phế Phẩm
        </button>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
